import {ERROR_CODES} from 'mobile/pages/checkout/store/reducers/orderData/orderDataType';

export const ITEMS_WITH_PRESCRIPTION_TYPE_KEY = 'itemsWithPrescriptionType';
export const QUICK_CHECKOUT_INITIALIZED = 'QuickCheckoutInitialized';

export const MODULE_KEY_CHECKOUT = 'checkoutPage';
export const GLASSES_CARE_SKU = 'insurance_20_20_recurring';
/**
 * This is temporary key for reducer inside MFE redux ecosystem
 * TODO When mobile checkout will be on 100% it must be replaced everywhere to MODULE_KEY_CHECKOUT
 */
export const MODULE_KEY_CHECKOUT_TEMP = '_checkoutPage';

export type OrderErrorType = {
    title: string;
    code?: ERROR_CODES | string;
    friendlyMessage?: string;
    detail?: {
        order_id?: string;
        orders_count?: number;
    };
    riskified_message?: string;
    riskified_status?: string;
};

export const EXTRA_URL_COOKIE_KEY = 'extraUrlData';
